import { render, staticRenderFns } from "./DirectChatList.vue?vue&type=template&id=0d6b7916&"
import script from "./DirectChatList.vue?vue&type=script&lang=js&"
export * from "./DirectChatList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports